<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  department.id
                    ? "Editar Departamento"
                    : "Cadastrar Departamento"
                }}
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Descrição:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            autocomplete="new-password"
                            v-model="department.description"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Gestor:
                          </label>
                          <v-select
                            :options="users"
                            label="name"
                            :reduce="(users) => users.id"
                            class="style-chooser"
                            v-model="department.user_id"
                          >
                            <div slot="no-options">Carregando...</div>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Empresa:
                          </label>
                          <v-select
                            :options="companies"
                            label="company_name"
                            :reduce="(companies) => companies.id"
                            class="style-chooser"
                            v-model="department.company_id"
                          >
                            <div slot="no-options">Carregando...</div>
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/departments" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      department: {
        description: "",
        company_id: "",
        user_id: "",
      },
      companies: [],
      users: [],
    };
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("description", self.department.description);
      fd.append("user_id", self.department.user_id);
      fd.append("company_id", self.department.company_id);

      if (self.department.id) {
        fd.append("id", self.department.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "departments";

      let fd = self.makeFormData();

      if (self.department.id) {
        api += "/" + self.department.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/departments");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDepartments: function (id) {
      const self = this;
      const api = self.$store.state.api + "departments/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.department = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers: function (id) {
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    self.getUsers();
    self.getCompanies();
    if (id) {
      self.getDepartments(id);
    }
  },
  components: {
    vSelect,
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Department/Add.vue